<div class="hidden sm:block">
  <div class=" flex flex-col justify-center items-center h-[20%] lg:h-[50%] pt-4 lg:pt-12">
    <div class="w-full md:w-10/12 lg:w-8/12 xl:w-9/12 rounded-2xl p-4 bg-white shadow-lg">
      <div class="card rounded-2xl overflow-hidden">
        <div class="flex flex-col md:flex-row items-center md:justify-between pb-0">
          <div class="w-full mb-4 md:mb-0 flex justify-start items-center">
            <img src="assets/images/getting-started-img/volmint-orbit-logo.png" alt="Orbit Image"
                 class="h-auto rounded-lg w-16 sm:w-20 md:w-24 lg:w-28">
            <div class="font-yantramanav text-lg md:text-xl font-semibold p-30px">
              <span class="fs-2" [style.font-family]="'var(--vex-font)'">
                {{content[pageExtras['currentIndex']].heading}}
              </span>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <img
            *ngIf="pageExtras['currentIndex'] !== 5 && pageExtras['currentIndex'] !== 6 && pageExtras['currentIndex'] !== 7"
            [src]="content[pageExtras['currentIndex']]?.image" alt="" class="w-full rounded-lg">
        </div>
        <div *ngIf="pageExtras['currentIndex'] === 5"
             class="profile-upload rounded-lg bg-gray-100 p-4 shadow-md overflow-y-scroll">
          <p class="text-red-600 my-2 animate-pulse">It is mandatory to upload profile picture in order to move forward.</p>

          <div class="image-upload flex flex-col items-center">
            <div class="image-cropper mb-4 text-center" *ngIf="imageChangedEvent">
              <image-cropper [imageChangedEvent]="imageChangedEvent" (imageCropped)="imageCropped($event)"
                             (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
                             (loadImageFailed)="loadImageFailed()">
              </image-cropper>
              <button (click)="fileChangeEvent()" class="mt-4 bg-blue-500 text-white px-4 py-2 rounded-lg">Save</button>
            </div>
            <div class="upload-icon mb-4">
              <input type="file" (change)="getImage($event)" id="file-upload" class="hidden">
              <label for="file-upload" *ngIf="user && user['profile_image']" class="cursor-pointer">
                <img [src]="user?.profile_image" alt="profile Image"
                     class="w-28 h-28 rounded-full object-cover shadow-1px-light">
              </label>
              <label for="file-upload" class="cursor-pointer flex flex-col items-center" *ngIf="!user?.profile_image">
                <i class="fa-solid fa-circle-user fa-4x"></i>
                <span class="text-gray-600 mt-2">Upload Image</span>
              </label>
            </div>
          </div>
          <div class="default-icons">
            <h3 class="text-lg font-semibold mb-2">Choose from our cool avatars</h3>
            <div class="icons-list flex flex-wrap justify-center">
              <img alt="icons" *ngFor="let icon of defaultProfileIcons" [src]="icon" (click)="selectDefaultIcon(icon)"
                   class="icon w-12 h-12 mx-2 cursor-pointer">
            </div>
          </div>
        </div>
        <form *ngIf="pageExtras['currentIndex'] === 6" class="h-[75%] md:h-2/4 px-6 md:px-20 text-center rounded-lg "
              [formGroup]="billingForm">
          <div class="flex flex-wrap justify-between">
            <mat-form-field [hideRequiredMarker]="true" class="w-full md:w-[calc(50%-20px)]" appearance="outline">
              <mat-label [style.font-family]="'var(--vex-font)'">GSTIN</mat-label>
              <input matInput placeholder="Enter organisation GST Identification Number" formControlName="gst_number"
                     [style.font-family]="'var(--vex-font)'"/>
            </mat-form-field>
            <mat-form-field [hideRequiredMarker]="true" class="w-full md:w-[calc(50%-20px)]" appearance="outline">
              <mat-label [style.font-family]="'var(--vex-font)'">PAN</mat-label>
              <input matInput placeholder="Enter organisation PAN" formControlName="pan_number"
                     [style.font-family]="'var(--vex-font)'"/>
            </mat-form-field>
            <small class="text-center mx-auto w-full mt-[-30px] mb-[10px] text-italic">
              Not providing your PAN and GSTIN may affect your future benefits.
            </small>
            <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4" appearance="outline"
                            [style.font-family]="'var(--vex-font)'">
              <mat-label>Country</mat-label>
              <mat-select #country placeholder="Select your country" formControlName="country_id"
                          (selectionChange)="getStates(country.value)" required>
                <mat-option [value]="defaultCountry?.id">{{defaultCountry?.name}}</mat-option>
                <mat-option *ngFor="let country of countries" [value]="country?.id">{{country?.name}}</mat-option>
              </mat-select>
              <small class="text-danger text-italic"
                     *ngIf="pageExtras['submitted'] && billingForm.get('country_id').hasError('required')">
                Country field is required
              </small>
            </mat-form-field>
            <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4"
                            *ngIf="pageExtras['selectedCountry'] == defaultCountry.id" appearance="outline"
                            [style.font-family]="'var(--vex-font)'">
              <mat-label>State</mat-label>
              <mat-select placeholder="Select organisation state" formControlName="state_id" required>
                <mat-option *ngFor="let state of states" [value]="state?.id">{{ state?.name }}</mat-option>
              </mat-select>
              <small class="text-danger text-italic" *ngIf="pageExtras['submitted'] && indianStateError">
                State field is required
              </small>
            </mat-form-field>
            <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4"
                            *ngIf="pageExtras['selectedCountry'] != defaultCountry.id" appearance="outline"
                            [style.font-family]="'var(--vex-font)'">
              <mat-label>State</mat-label>
              <input matInput placeholder="Enter organisation state" formControlName="foreign_state_name">
              <small class="text-danger text-italic" *ngIf="pageExtras['submitted'] && foreignStateError">
                State field is required
              </small>
            </mat-form-field>
            <mat-form-field class="w-full mb-4" appearance="outline" [style.font-family]="'var(--vex-font)'">
              <mat-label>Address</mat-label>
              <input matInput placeholder="Enter your billing address" formControlName="address" required>
              <small class="text-danger text-italic"
                     *ngIf="pageExtras['submitted'] && billingForm.get('address').hasError('required')">
                Address field is required
              </small>
            </mat-form-field>
            <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4" appearance="outline"
                            [style.font-family]="'var(--vex-font)'">
              <mat-label>City</mat-label>
              <input matInput placeholder="Enter organisation city" formControlName="city" required>
              <small class="text-danger text-italic"
                     *ngIf="pageExtras['submitted'] && billingForm.get('city').hasError('required')">
                City field is required
              </small>
            </mat-form-field>
            <mat-form-field class="w-full md:w-[calc(50%-20px)] mb-4" appearance="outline"
                            [style.font-family]="'var(--vex-font)'">
              <mat-label>Zip Code</mat-label>
              <input matInput placeholder="Enter organisation zip code" formControlName="zip_code" required numbersOnly>
              <small class="text-danger text-italic"
                     *ngIf="pageExtras['submitted'] && billingForm.get('zip_code').hasError('required')">Zip code field
                is required</small>
            </mat-form-field>
          </div>
        </form>
        <!--<iframe *ngIf="pageExtras['currentIndex'] === 7" class="w-full mx-auto mt-4" height="450" width="100%"
                src="https://www.youtube.com/embed/_2GrFAg9auU?si=tgM1nn1YQAy3SOVZ"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>-->
      </div>
    </div>
    <!-- Pagination and Navigation -->
    <div class="w-full md:w-10/12 lg:w-8/12 xl:w-9/12 mt-4">
      <div class="flex justify-between items-center">
        <button [disabled]="pageExtras['currentIndex'] === 0"
                class="font-dm border bg-[#FFFFFF] text-black px-8 md:px-12 py-3 rounded-sm font-medium whitespace-nowrap"
                (click)="previous()">
          <i class="fa fa-long-arrow-left" aria-hidden="true"></i> Back
        </button>
        <div class="flex items-center justify-center w-full md:w-1/3">
          <ng-container *ngFor="let el of content; let i = index">
        <span
          class="mx-2 w-2 h-2 rounded-full bg-[#FFFFFF] hover:bg-[#564492] {{pageExtras['currentIndex'] === i ? 'bg-[#564492]' : ''}}"></span>
          </ng-container>
        </div>
        <button class="font-dm bg-[#FFFFFF] text-black px-8 md:px-12 py-3 rounded-sm font-medium whitespace-nowrap"
                (click)="next()" [disabled]="btnActive" [style.font-family]="'var(--vex-font)'">
          {{pageExtras['buttonText']}} <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="sm:hidden ">
  <div class="h-full ">
    <div class="flex flex-col md:flex-row items-center md:justify-between pb-0">
      <div class="w-full  mb-4 md:mb-0 ">
        <img src="assets/images/getting-started-img/volmint-orbit-logo.png" alt="Orbit Image"
             class="w-[50px] mx-auto h-auto rounded-lg">
        <div class="font-yantramanav rounded-lg mt-2 p-2 bg-white text-center text-[14px] font-semibold">
          <span class="">{{ content[pageExtras['currentIndex']].heading }}</span>
        </div>
      </div>
    </div>
    <div class="card px-0 rounded-2xl overflow-y-auto">
      <div class="text-center">
        <img *ngIf="pageExtras['currentIndex'] ===0"
             src="assets/images/getting-started-img/welcome-to-orbit-mob.webp" alt="" class="h-full mx-auto rounded-lg">
        <img *ngIf="pageExtras['currentIndex'] ===1"
             src="assets/images/getting-started-img/enhance-workflow.gif" alt="" class="h-full mx-auto rounded-lg">
        <img *ngIf="pageExtras['currentIndex'] ===2"
             src="assets/images/getting-started-img/save-time-cost.gif" alt="" class="h-full mx-auto rounded-lg">
        <img *ngIf="pageExtras['currentIndex'] ===3"
             src="assets/images/getting-started-img/collaborate-better-with-teams-mob.gif" alt="" class="h-full mx-auto rounded-lg">
        <img *ngIf="pageExtras['currentIndex'] ===4"
             src="assets/images/getting-started-img/orbit-empowering-organization.gif" alt="" class="h-full mx-auto rounded-lg">
      </div>
      <div *ngIf="pageExtras['currentIndex'] === 5"
           class="w-full border rounded-lg bg-gray-100 p-0 shadow-md my-auto">
        <p class="text-red-600 my-2 animate-pulse mx-2">It is mandatory to upload profile picture in order to move forward.</p>

        <div class="image-upload items-center">
          <div class="image-cropper py-3" *ngIf="imageChangedEvent">
            <image-cropper [imageChangedEvent]="imageChangedEvent" (imageCropped)="imageCropped($event)"
                           (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
                           (loadImageFailed)="loadImageFailed()">
            </image-cropper>
            <button (click)="fileChangeEvent()" class="mt-4 bg-blue-500 text-white px-4 py-2 rounded-lg">Save</button>
          </div>
          <div class="upload-icon py-3">
            <input type="file" (change)="getImage($event)" id="file-upload" class="hidden">
            <label for="file-upload" *ngIf="user && user['profile_image']" class="cursor-pointer">
              <img [src]="user?.profile_image" alt="profile Image"
                   class="w-20 h-20 rounded-full object-cover shadow-1px-light">
            </label>
            <label for="file-upload" class="cursor-pointer flex flex-col items-center" *ngIf="!user?.profile_image">
              <i class="fa-solid fa-circle-user fa-4x"></i>
              <span class="text-gray-600 mt-2">Upload Image</span>
            </label>
            <!--<input type="file" (change)="getImage($event)" id="file-upload" class="hidden">
            <img [src]="user?.profile_image" alt="profile Image"
                 *ngIf="user?.profile_image"
                 class="w-28 h-28 rounded-full  object-cover shadow-1px-light">
            <label for="file-upload" class="cursor-pointer flex flex-col items-center" *ngIf="!user?.profile_image">
              <i class="fa-solid fa-circle-user fa-4x"></i>
              <span class="text-gray-600 mt-2">Upload Image</span>
            </label>-->
          </div>
        </div>
        <div class="default-icons mt-0 w-full">
          <h3 class="text-lg font-semibold mb-2">Choose from our cool avatars</h3>
          <div class="icons-list pb-10 flex w-full justify-center">
            <img *ngFor="let icon of defaultProfileIcons" [src]="icon" (click)="selectDefaultIcon(icon)"
                 class="icon w-12 h-12 mx-2 cursor-pointer">
          </div>
        </div>
      </div>
      <div class="h-full w-full overflow-y-scroll" *ngIf="pageExtras['currentIndex'] === 6">
        <form class=" overflow-y-hidden pt-2 md:h-2/4 md:px-20 text-center rounded-lg "
              [formGroup]="billingForm">
          <div class="flex flex-wrap justify-between">
            <mat-form-field [hideRequiredMarker]="true" class="w-full " appearance="outline">
              <mat-label>GSTIN</mat-label>
              <input matInput placeholder="Enter organisation GST Identification Number" formControlName="gst_number"
                     numbersOnly>
            </mat-form-field>
            <mat-form-field [hideRequiredMarker]="true" class="w-full " appearance="outline">
              <mat-label>PAN</mat-label>
              <input matInput placeholder="Enter organisation PAN" formControlName="pan_number" numbersOnly>
            </mat-form-field>
            <p class="text-center mx-auto w-full mt-[-30px] mb-[10px]">
              Enter GSTIN may affect your future benefits.
            </p>
            <mat-form-field class="w-full  mb-4" appearance="outline">
              <mat-label>Country</mat-label>
              <mat-select #country placeholder="Select your country" formControlName="country_id"
                          (selectionChange)="getStates(country.value)" required>
                <mat-option [value]="defaultCountry?.id">{{ defaultCountry?.name }}</mat-option>
                <mat-option *ngFor="let country of countries" [value]="country?.id">{{ country?.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full  mb-4"
                            *ngIf="pageExtras['selectedCountry'] == defaultCountry.id" appearance="outline">
              <mat-label>State</mat-label>
              <mat-select placeholder="Select organisation state" formControlName="state_id" required>
                <mat-option *ngFor="let state of states" [value]="state?.id">{{ state?.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full  mb-4"
                            *ngIf="pageExtras['selectedCountry'] != defaultCountry.id" appearance="outline">
              <mat-label>State</mat-label>
              <input matInput placeholder="Enter organisation state" formControlName="foreign_state_name">
              <small class="text-danger text-italic"
                     *ngIf="pageExtras['submitted'] && billingForm.get('foreign_state_name').hasError('required')">State
                field is required</small>
            </mat-form-field>
            <mat-form-field class="w-full mb-4" appearance="outline">
              <mat-label>Address</mat-label>
              <input matInput placeholder="Enter your billing address" formControlName="address">
            </mat-form-field>
            <mat-form-field class="w-full  mb-4" appearance="outline">
              <mat-label>City</mat-label>
              <input matInput placeholder="Enter organisation city" formControlName="city" required>
              <small class="text-danger text-italic"
                     *ngIf="pageExtras['submitted'] && billingForm.get('city').hasError('required')">City field is
                required</small>
            </mat-form-field>
            <mat-form-field class="w-full  mb-4" appearance="outline">
              <mat-label>Zip Code</mat-label>
              <input matInput placeholder="Enter organisation zip code" formControlName="zip_code" required numbersOnly>
              <small class="text-danger text-italic"
                     *ngIf="pageExtras['submitted'] && billingForm.get('zip_code').hasError('required')">Zip code field
                is required</small>
            </mat-form-field>

          </div>
        </form>
      </div>
      <iframe *ngIf="pageExtras['currentIndex'] === 7 " class="w-full mx-auto mt-4" height="350" width="100%"
              src="https://www.youtube.com/embed/_2GrFAg9auU?si=tgM1nn1YQAy3SOVZ"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
    <div class="w-full md:w-10/12 lg:w-8/12 xl:w-9/12 mt-4">
      <div class="flex justify-between items-center">
        <button [disabled]="pageExtras['currentIndex'] === 0"
                class="font-dm border bg-[#FFFFFF] text-black px-2 md:px-12 py-2 rounded-sm font-medium whitespace-nowrap"
                (click)="previous()">
          <i class="fa fa-long-arrow-left" aria-hidden="true"></i> Back
        </button>
        <button class="font-dm bg-[#FFFFFF] text-black px-2 md:px-12 py-2 rounded-sm font-medium whitespace-nowrap"
                (click)="next()" [disabled]="btnActive">
          {{ pageExtras['buttonText'] }} <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>
